import { Grid } from "@mui/material";
import { MetricDrillDownInfo } from "../../../../../api/biApi.types";
import { DrillDownPage } from "../../../../../store/types/drillDownPageState.types";
import PmPart from "./PmPart";

interface Props {
  configuration: DrillDownPage;
  info: MetricDrillDownInfo;
}

const PmPage = ({ configuration, info }: Props) => {
  return (
    <Grid container sx={{ flex: 1, width: "100%" }}>
      <PmPart configuration={configuration} info={info} />
    </Grid>
  );
};

export default PmPage;
